import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/services/util.service';
import { localStorageKeys } from '../const/enum';
import { canAccessConsoleLog } from '../utils/console-log-access';

@Injectable({
  providedIn: 'root'
})
export class ConsoleLogGuard {
  constructor(
    private router: Router,
    private utilService: UtilService
  ) { }

  canActivate(): boolean {
    const allowed = canAccessConsoleLog(
      this.utilService.getLocalStorage(localStorageKeys.userDetails),
      this.utilService.loginUserType || this.utilService.getLocalStorage(localStorageKeys.roleType)
    );

    if (allowed) {
      return true;
    }

    this.router.navigate(['/new-dashboard']);
    return false;
  }
}
